import { Dimension } from '@/Enums/ReportBuilder/Dimension.enum';
import { DimensionGroup } from '@/Enums/ReportBuilder/DimensionGroup.enum';
import { Metric } from '@/Enums/ReportBuilder/Metric.enum';
import { IControlOption, IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { createMetricOption, hydrateOptionGroup } from '.';

interface IGetDimensionOptions {
  includeOrganization?: boolean;
}

export const getDimensionOptions = (options?: IGetDimensionOptions): IGroupedControlOption<string, Dimension>[] => [
  ...hydrateOptionGroup(
    [
      options?.includeOrganization ? Dimension.ORGANIZATION_NAME : undefined,
      Dimension.CLIENT_NAME,
      Dimension.ADVERTISER_NAME,
      Dimension.CAMPAIGN_NAME,
      Dimension.LINE_ITEM_NAME,
    ].filter(Boolean) as Dimension[],
    DimensionGroup.HighLevel,
  ),
];

export const METRICS_OPTIONS: IControlOption<string, Metric>[] = [
  Metric.IMPRESSIONS,
  Metric.VIDEO_COMPLETES,
  Metric.CLICKS,
  Metric.VIDEO_Q1S,
  Metric.VIDEO_MIDPOINTS,
  Metric.VIDEO_Q3S,
].map(createMetricOption);
